import { GET_ADD_INHOUSE, GET_DELETE_INHOUSE } from "../../sharedFile/actionType";
export const addInhouse = (data) => ({
    type: GET_ADD_INHOUSE,
    data,
})
export const deleteInhouse = (data) => ({
    type: GET_DELETE_INHOUSE,
    data,
})